// Registro de resolvers de "entrada no módulo" pela navegação client-centric.
//
// Alguns módulos precisam de lógica própria ao serem acessados com um cliente
// ativo (ex.: CRM consulta o backend pra saber se o cliente é lead ou cliente
// antes de decidir pra onde navegar e com qual mode abrir o modal). Em vez de
// acoplar esse conhecimento na sidebar genérica (navegacao-v2-sidebar.vue), cada
// módulo registra seu próprio resolver aqui — a sidebar só sabe invocar pela
// chave do módulo (item.clienteEntranceModule), nunca importa nada do módulo em si.
//
// Contrato do resolver: async ({ client, item }) => { routeName?, params?, modal?: { name, payload } } | null
// params é opcional — só módulos com rota dinâmica por cliente (ex: Wealth
// Service, ws.clients.codigo) precisam declará-lo; a maioria (CRM/Compliance)
// usa rotas estáticas e não passa params.
const resolvers = new Map()

/**
 * @param {string} moduleKey chave do módulo (ex: 'crm')
 * @param {(ctx: {client: Object, item: Object}) => Promise<{routeName?: string, params?: Object, modal?: {name: string, payload: Object}}>} resolver
 */
export function registerClienteEntranceResolver(moduleKey, resolver) {
  resolvers.set(moduleKey, resolver)
}

/**
 * @param {string} moduleKey
 * @param {Object} ctx { client, item }
 * @returns {Promise<{routeName?: string, params?: Object, modal?: {name: string, payload: Object}}|null>}
 *   null quando não há resolver registrado para o módulo — a sidebar cai no
 *   fallback de navegação normal (resolveDynamicRoute/clienteSkipTo).
 */
export async function resolveModuleEntranceCliente(moduleKey, ctx = {}) {
  const resolver = moduleKey && resolvers.get(moduleKey)
  if (!resolver) return null
  return (await resolver(ctx)) || null
}

// Uso exclusivo em testes — evita vazamento de resolvers registrados entre suítes.
export function _resetClienteEntranceResolvers() {
  resolvers.clear()
}
